module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lista-solicitud-vacaciones contenedor-interno"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('span', [_vm._v("Solicitudes de permiso por aprobar")]), _c('span', {
    staticClass: "icon close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  })])]), (_vm.mostrarConfirmacionAprobar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "aprobarSolicitud",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobar = false
      },
      "do": _vm.aprobar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazar) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazar",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazar = false
      },
      "do": _vm.rechazar
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar la solicitud?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionRechazarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarRechazarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionRechazarMasiva = false
      },
      "do": _vm.rechazarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea rechazar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Rechazando...")] : [_vm._v("Rechazar")]], 2)])], 1) : _vm._e(), (_vm.mostrarConfirmacionAprobarMasiva) ? _c('transition', {
    attrs: {
      "name": "fade",
      "tag": "div"
    }
  }, [_c('confirmar-accion-overlay', {
    ref: "confirmarAprobarMasiva",
    on: {
      "close": function($event) {
        _vm.mostrarConfirmacionAprobarMasiva = false
      },
      "do": _vm.aprobarMasivo
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v("¿Desea aprobar masivamente?")]), _c('span', {
    attrs: {
      "slot": "primaryAction"
    },
    slot: "primaryAction"
  }, [(_vm.isSending) ? [_vm._v("Aprobando...")] : [_vm._v("Aprobar")]], 2)])], 1) : _vm._e(), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mb-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_vm._m(0), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_vm._m(1), _c('span', [_vm._v("Rechazar")])])]) : _vm._e(), _c('div', {
    staticClass: "body"
  }, [_c('transition-group', {
    staticClass: "contenedor-transition",
    attrs: {
      "name": "fade-smooth-two",
      "tag": "div"
    }
  }, [(!_vm.isLoading && _vm.lista.length === 0) ? _c('div', {
    key: "mensaje_no_solicitudes",
    staticClass: "mensaje-informacion"
  }, [_c('div', {
    staticClass: "message is-info"
  }, [_c('div', {
    staticClass: "message-body"
  }, [_c('span', [_vm._v("No hay solicitudes de permisos de su equipo por aprobar")])])])]) : _vm._e(), _c('div', {
    key: "div-table-solicitud-por-aprobar",
    staticClass: "is-desktop"
  }, [(_vm.lista.length > 0) ? _c('table', {
    key: "table-solicitud-por-aprobar",
    staticClass: "table is-striped is-bordered"
  }, [_c('thead', [_c('th', [_c('input', {
    attrs: {
      "type": "checkbox",
      "name": "solicitud"
    },
    domProps: {
      "checked": _vm.seleccionadosTodos
    },
    on: {
      "change": function($event) {
        return _vm.check('all')
      }
    }
  })]), _c('th', [_vm._v("Empleado")]), _c('th', [_vm._v("Tipo")]), _c('th', [_vm._v("Motivo")]), _c('th', [_vm._v("Acciones")])]), _c("transition-group", {
    tag: "tbody",
    attrs: {
      "name": "table-row"
    }
  }, _vm._l((_vm.lista), function(o) {
    return _c('tr', {
      key: o.id + 'id',
      staticClass: "row-table",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('td', {
      staticClass: "ta-center"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('td', [_c('div', {
      staticClass: "flex aic"
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('div', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [_c('span', {
      staticClass: "hint--right",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])])])]), _c('td', [_vm._v(_vm._s(o.descripcionTipo))]), _c('td', [(o.motivo) ? [_c('span', [_vm._v(_vm._s(o.motivo))])] : [_c('span', [_vm._v("Sin motivo")])], _c('br'), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde) + _vm._s(i.desde === i.hasta ? '' : ' - ' + i.hasta) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2)], 2), _c('td', {
      staticClass: "text-center"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : [_c('span', {
      staticClass: "no-accion"
    }, [_vm._v("Sin adjunto")])], (o.estado === 2 && !_vm.isSeleccionMasiva) ? _c('div', {
      staticClass: "contenedor-acciones"
    }, [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)])
  }), 0)], 1) : _vm._e()]), _c('div', {
    key: "div-card-solicitud-por-aprobar",
    staticClass: "is-mobile"
  }, [_vm._l((_vm.lista), function(o, index) {
    return _c('div', {
      key: o.id + 'id',
      staticClass: "box",
      class: {
        'row-info': o.esDeDelegacion
      }
    }, [_c('div', {
      staticClass: "checkbox"
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "id": o.id
      },
      domProps: {
        "checked": o.seleccionado
      },
      on: {
        "change": function($event) {
          return _vm.check(o)
        }
      }
    })]), _c('div', {
      staticClass: "empleado hint--right",
      attrs: {
        "aria-label": 'Solicitud: ' + o.id
      }
    }, [(o.esDeDelegacion) ? _c('span', {
      staticClass: "hint--top margin-right-5",
      attrs: {
        "aria-label": 'Solicitud Delegada'
      }
    }, [_c('i', {
      staticClass: "fa fa-exclamation-circle"
    })]) : _vm._e(), _c('span', {
      staticClass: "hint--bottom",
      attrs: {
        "aria-label": 'Empleado: ' + o.dniEmpleado
      }
    }, [_vm._v(_vm._s(o.nombreEmpleado))])]), _c('div', {
      staticClass: "descripcion-tipo"
    }, [_c('span', [_vm._v(_vm._s(o.descripcionTipo))])]), _c('div', {
      staticClass: "motivo"
    }, [_c('span', [_vm._v(_vm._s(o.motivo))])]), _c('div', {
      staticClass: "dias-pedidos"
    }, [_c('strong', [_vm._v("Dias pedidos")]), _vm._l((o.detalle), function(i) {
      return _c('div', [_c('span', {
        staticClass: "detalle-dias"
      }, [_vm._v(_vm._s(i.desde === i.hasta ? i.desde : ((i.desde) + " - " + (i.hasta))) + "   " + _vm._s(i.horaDesde) + "-" + _vm._s(i.horaHasta))])])
    })], 2), _c('div', {
      staticClass: "botones"
    }, [(o.adjunto) ? [_c('a', {
      staticClass: "button is-small",
      attrs: {
        "href": o.adjunto,
        "target": "_blank"
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paperclip is-small fs-12"
    })]), _c('span', [_vm._v("Ver adjunto")])])] : _vm._e(), (o.estado === 2 && !_vm.isSeleccionMasiva) ? [_c('button', {
      staticClass: "button is-small",
      on: {
        "click": function($event) {
          return _vm.confirmarAprobar(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-paper-plane-o"
    })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
      staticClass: "button is-small is-danger",
      on: {
        "click": function($event) {
          return _vm.confirmarRechazo(o)
        }
      }
    }, [_c('span', {
      staticClass: "icon is-small"
    }, [_c('i', {
      staticClass: "fa fa-times"
    })]), _c('span', [_vm._v("Rechazar")])])] : _vm._e()], 2)])
  }), (_vm.isSeleccionMasiva) ? _c('div', {
    staticClass: "acciones display-flex aic jcc mt-10"
  }, [_c('button', {
    staticClass: "button is-small margin-right-5",
    on: {
      "click": _vm.confirmarAprobarMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })]), _c('span', [_vm._v("Aprobar")])]), _c('button', {
    staticClass: "button is-small is-danger",
    on: {
      "click": _vm.confirmarRechazoMasivo
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })]), _c('span', [_vm._v("Rechazar")])])]) : _vm._e()], 2)]), (_vm.isLoading) ? _c('loading') : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-paper-plane-o"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3650b498","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Permisos_Lista_Solicitudes_Por_Aprobar.vue
// module id = 788
// module chunks = 0